<template>
  <div class="whole">
    <m-header></m-header>
    <m-sidebar></m-sidebar>
    <div class="data-content">
      <div class="now-date">
        财务管理
      </div>
    </div>
  </div>
</template>

<script>
import { Loading } from 'element-ui'
import MSidebar from 'components/header/sidebar'
import MHeader from 'components/header/header'
import {getAllUser, saveUser, deleteUser,freezeUser,getPushUser} from 'api/request'
import {getDepartment} from 'api/post'
import {ERR_OK} from 'api/config'
import {formatDate, loadingInstance, Success, Error} from 'common/js/util'
export default {
  components: { MSidebar,MHeader },
  data() {
    return {
      formatDate:"",
      pageSize: 10,
      pageNum: 1,
      totalPage: 0,
      keywords: null,
      paginationShow: false,
      detailDialogVisible: false,
      pushDialogVisible: false,
      editDialogVisible: false,
      freezeDialogVisible: false,
      deleteDialogVisible: false,
      controlData: {},
      userDetail: [],
      userDatas: [],
      pushUserDatas: [],
      multipleSelection: []
    }
  },
  mounted () {
    this.formatDate = this.getNowFormatDate();
    let getUserInfo = JSON.parse(window.localStorage.getItem('getUserInfo'));
    if (!getUserInfo) {
      this.$router.push({
        path: '/'
      })
    }else{
      //this._getList();
    }
  },
  methods: {
    getNowFormatDate() {
       var date = new Date();
       var year = date.getFullYear();
       var month = date.getMonth() + 1;
       var strDate = date.getDate();
       var day = date.getDay();
       var weeks = new Array("星期日", "星期一", "星期二", "星期三", "星期四", "星期五", "星期六");
       var week = weeks[day];
       if (month >= 1 && month <= 9) {
           month = "0" + month;
       }
       if (strDate >= 0 && strDate <= 9) {
           strDate = "0" + strDate;
       }
       var currentdate = year + "年" + month + "月" + strDate+"日"+week;
       return currentdate;
    }
  },
}
</script>
<style scoped>

</style>
<style>
  .now-date{
    width:fit-content;
    margin: 20px;
    display: inline-block;
    float: left;
    font-size: 25px;
    color: #333333;
  }
</style>



// WEBPACK FOOTER //
// src/components/balance/balance.vue